export default __webpack_public_path__ + "static/media/training@3x.588a4f29.png";